exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dialogchoice h1:not(.site-title):before,\n.dialogchoice h2:before {\n  display: none;\n}\n\n.dialogchoice .button-wrapper{\n  justify-content: center;\n  display: flex;\n}\n\n.dialogchoice .button-wrapper svg{\n  font-size: 4em;\n}\n", ""]);

